import React, { useEffect, useState } from "react";
import api from "../api";
import { toast } from "react-toastify";

const VendorDashboardPage = () => {
  const [redemptions, setRedemptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 1. Get current user from local storage
    const storedUser = localStorage.getItem("currentUser");
    if (storedUser) {
      const user = JSON.parse(storedUser);


      // Check for 'id' OR 'userId'
      const vendorId = user.id || user.userId;

      if (vendorId) {
        fetchDashboardData(vendorId);
      } else {
        console.error("❌ Vendor ID is missing in currentUser object:", user);
        toast.error("Error: Vendor ID not found. Please log out and log in again.");
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, []);

  const fetchDashboardData = async (vendorId) => {
    try {
      const response = await api.get(`/vres/redemption/vendor/${vendorId}/dashboard`);
      setRedemptions(response.data || []);
    } catch (error) {
      console.error("Error fetching vendor dashboard:", error);
      toast.error("Failed to load dashboard data.");
    } finally {
      setLoading(false);
    }
  };

  // --- STYLES INJECTION ---
  const PageStyleBlock = () => (
    <style>{`
      .vd-table th {
          background-color: #f8f9fa;
          color: #636e72;
          font-weight: 600;
          padding: 12px;
          border-bottom: 2px solid #e1e4e8;
          font-size: 0.9rem;
          text-align: left;
      }
      .vd-table td {
          padding: 12px;
          border-bottom: 1px solid #e1e4e8;
          font-size: 0.85rem;
          vertical-align: middle;
          color: #2d3436;
      }
      .vd-table tr:hover { background-color: #fcfcfc; }

      /* --- 🔴 CRITICAL PRINT STYLES --- */
      @media print {
          @page {
              size: A4;
              margin: 10mm;
          }
          body, html, #root {
              height: auto !important;
              overflow: visible !important;
              background-color: white !important;
          }
          .contentWrapper {
              height: auto !important;
              overflow: visible !important;
              padding: 0 !important;
              margin: 0 !important;
              display: block !important;
          }
          .card {
              border: 1px solid #ccc !important;
              box-shadow: none !important;
              break-inside: avoid;
              page-break-inside: auto; /* Allow tables to break */
          }
          /* Reset Flex/Grid Containers */
          div[style*="height: 100%"] {
              height: auto !important;
              display: block !important;
          }
          table { page-break-inside: auto; }
          tr { page-break-inside: avoid; }
      }
    `}</style>
  );

  if (loading) {
    return <div style={{ padding: '40px', textAlign: 'center', color: '#636e72' }}>Loading dashboard...</div>;
  }

  return (
    <div style={styles.container}>
      <PageStyleBlock />

      <div style={styles.contentWrapper} className="contentWrapper">
        {/* Card Container with Teal Border */}
        <div style={styles.card} className="card">
          <div style={styles.cardHeader}>
            <h4 style={{ margin: 0, fontSize: '1.1rem', color: '#2d3436' }}>
                Redeemed Vouchers History ({redemptions.length})
            </h4>
          </div>
          
          <div style={{ overflowX: 'auto' }}>
            {redemptions.length === 0 ? (
                <div style={{ padding: '40px', textAlign: 'center', color: '#636e72' }}>
                    No vouchers have been redeemed by you yet.
                </div>
            ) : (
                <table className="vd-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th>Redeemed Date</th>
                            <th>Beneficiary Name</th>
                            <th>Project</th>
                            <th>Voucher Points</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {redemptions.map((item, index) => (
                            <tr key={index}>
                                <td>{item.redeemedDate}</td>
                                <td>{item.beneficiaryName}</td>
                                <td>{item.projectTitle}</td>
                                <td>
                                    <span style={{ 
                                        backgroundColor: '#d1e7dd', 
                                        color: '#0f5132', 
                                        padding: '4px 8px', 
                                        borderRadius: '4px', 
                                        fontSize: '0.8rem', 
                                        fontWeight: 'bold' 
                                    }}>
                                        {item.voucherPoints}
                                    </span>
                                </td>
                                <td>
                                    <span style={{ 
                                        backgroundColor: '#cff4fc', 
                                        color: '#055160', 
                                        padding: '4px 8px', 
                                        borderRadius: '4px', 
                                        fontSize: '0.8rem', 
                                        fontWeight: 'bold' 
                                    }}>
                                        {item.status}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    backgroundColor: '#f0fdf9', // Teal Background
    fontFamily: "'Segoe UI', Roboto, sans-serif",
  },
  // Top Header Style
  topHeader: {
    backgroundColor: 'white',
    padding: '0 40px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #e1e4e8',
    height: '70px',
    flexShrink: 0,
    zIndex: 10,
    position: 'sticky',
    top: 0
  },
  topHeaderTitle: {
    fontSize: '1.2rem',
    color: '#2d3436',
    margin: 0,
    fontWeight: '700',
  },
  contentWrapper: {
    padding: '30px',
    flexGrow: 1,
    overflowY: 'auto',
  },
  // Card Styles
  card: {
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 10px 25px rgba(0,0,0,0.04)',
    borderTop: '5px solid #20c997', // ✅ TEAL BORDER
    overflow: 'hidden',
  },
  cardHeader: {
    padding: '20px 25px',
    borderBottom: '1px solid #e1e4e8',
    backgroundColor: 'white',
  }
};

export default VendorDashboardPage;